const ZEUSBOX_BASE_PATH = "/";

export default {
  ZEUSBOX_BASE_PATH,
};